<template>
  <input
    v-on="inputListeners"
    type="search"
    placeholder="Search"
    class="base-search-input"
  />
</template>

<script>
export default {
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event.target.value);
        },
      };
    },
  },
};
</script>
